import { Column } from '@prisjakt/ui/list/variants';
import { Panel, PanelHeader, PanelTitle } from '@prisjakt/ui/panel';
import { BodyMediumText } from '@prisjakt/ui/text/variants';
import React from 'react';
import { useAppContext } from 'src/components/app-context';
import type { CampaignPageThemesQuery } from 'src/types';
import type { RequiredNotNull } from 'src/utils/types';
import { ColumnWithGutter } from './styles';
import * as S from '../campaign-header/styles';
import CampaignBreadcrumb from '../breadcrumb';
import ThemeListItem from './list-item';

const validCampaignTypes = ['OFFER'];

export const Themes = ({
  campaigns,
}: RequiredNotNull<Pick<CampaignPageThemesQuery, 'campaigns'>>) => {
  const { t, market } = useAppContext();
  const getCampaigns = (ongoing: any) =>
    campaigns?.filter(campaign =>
      ongoing
        ? campaign?.state === 'ACTIVE' &&
          validCampaignTypes.indexOf(campaign.type ?? '') >= 0
        : campaign?.state === 'UPCOMING' &&
          validCampaignTypes.indexOf(campaign.type ?? '') >= 0
    );

  const ongoingCampaigns = getCampaigns(true);
  const upcomingCampaigns = getCampaigns(false);
  const imageHeaderSource = `${market.cdn}/g/campaigns/themes/campaigns-logo.png`;

  return (
    <>
      <CampaignBreadcrumb />
      <S.Header>
        <S.Container>
          <S.Logo>
            <img src={imageHeaderSource} alt={t('campaigns', 'themes.title')} />
          </S.Logo>
          <S.Content>
            <S.Title>{t('campaigns', 'themes.title')}</S.Title>
            <BodyMediumText container="p">
              {t('campaigns', 'themes.description')}
            </BodyMediumText>
          </S.Content>
        </S.Container>
      </S.Header>
      <ColumnWithGutter>
        <Column gap={4}>
          {ongoingCampaigns?.length !== 0 && (
            <Panel>
              <PanelHeader>
                <PanelTitle container="h2">
                  {t('campaigns', 'themes.ongoing-campaigns')}
                </PanelTitle>
              </PanelHeader>
              <Column gap={2}>
                {ongoingCampaigns?.map(
                  campaign =>
                    campaign && (
                      <ThemeListItem key={campaign.name} campaign={campaign} />
                    )
                )}
              </Column>
            </Panel>
          )}
          {upcomingCampaigns?.length !== 0 && (
            <Panel>
              <PanelHeader>
                <PanelTitle container="h2">
                  {t('campaigns', 'themes.upcoming-campaigns')}
                </PanelTitle>
              </PanelHeader>
              <Column gap={2}>
                {upcomingCampaigns
                  .filter(campaign => campaign?.type === 'OFFER')
                  .map(
                    campaign =>
                      campaign && (
                        <ThemeListItem
                          key={campaign.name}
                          campaign={campaign}
                        />
                      )
                  )}
              </Column>
            </Panel>
          )}
        </Column>
      </ColumnWithGutter>
    </>
  );
};
